import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";

interface StudentNameChipProps {
    name: string;
    /** Screen reader label for the remove button, e.g. "Remove". */
    removeLabel: string;
    onRemove: () => void;
}

const StudentNameChip = (props: StudentNameChipProps) => (
    <div className="flex items-center gap-xs bg-background-light border border-p6-grey-light rounded-pill pl-s pr-xs py-xxs min-h-[33px] text-p6-grey-dark">
        <span className="text-l">{props.name}</span>
        <button
            type="button"
            aria-label={`${props.removeLabel} ${props.name}`}
            onClick={props.onRemove}
            className="flex items-center justify-center w-[25px] h-[25px] bg-transparent border-none cursor-pointer p-no shrink-0"
        >
            <PhaseSixIcon
                name="close"
                className="text-l"
            />
        </button>
    </div>
);

export default StudentNameChip;
